module.exports = __webpack_public_path__ + "img/banner-sedes.2dea964c.png";